module.exports = __webpack_public_path__ + "img/menu_support.9b83f183.svg";